export function AccAuditScheduleItemFactory() {
    return function AccAuditScheduleItem() {

        this.id = null; //ash_id
        this.name = null;
        this.standard = null;
        this.description = null;
    };
}
